export default __webpack_public_path__ + "static/media/kitchen_D112-2X20-MBP-EI90.15249db5.jpg";